import { type InsuranceCorporateIdentity } from "../types";

export function WerraMeissnerLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_31_4613)">
        <path
          d="M156.064 255.952H160.993L167.431 227.244H167.532L173.869 255.952H178.899L186.243 222.426H182.118L176.284 249.628H176.183L170.147 222.426H164.816L158.78 249.628H158.679L153.147 222.426H148.821L156.064 255.952Z"
          fill="#05509E"
        />
        <path
          d="M188.657 255.952H204.853V252.338H192.882V240.494H203.646V236.679H192.882V226.14H204.249V222.426H188.657V255.952Z"
          fill="#05509E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M209.178 255.952H213.403V240.795H215.315C218.433 240.795 219.64 241.798 220.646 244.609L224.469 255.952H228.996L224.268 242.501C223.564 240.594 222.658 239.59 220.646 239.289V239.189C225.576 238.185 227.286 234.772 227.286 231.158C227.286 228.749 226.481 226.441 224.771 224.835C223.262 223.429 221.25 222.526 217.729 222.526H209.178V255.952ZM213.403 225.939H216.723C220.445 225.939 222.86 227.746 222.86 231.46C222.86 234.37 221.149 237.382 216.623 237.382H213.403V225.939Z"
          fill="#05509E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M232.517 255.952H236.742V240.795H238.653C241.772 240.795 242.979 241.798 243.985 244.609L247.807 255.952H252.334L247.606 242.501C246.902 240.594 245.997 239.59 243.985 239.289V239.189C248.914 238.185 250.624 234.772 250.624 231.158C250.624 228.749 249.819 226.441 248.109 224.835C246.6 223.429 244.588 222.526 241.068 222.526H232.517V255.952ZM236.641 225.939H239.961C243.683 225.939 246.097 227.746 246.097 231.46C246.097 234.37 244.387 237.382 239.86 237.382H236.641V225.939Z"
          fill="#05509E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M263.601 222.426L252.334 255.952H256.559L259.275 247.219H272.152L274.868 255.952H279.294L268.228 222.426H263.601ZM260.482 243.605L265.713 226.842H265.814L270.944 243.605H260.482Z"
          fill="#05509E"
        />
        <path
          d="M279.797 240.795H290.259V244.208H279.797V240.795Z"
          fill="#05509E"
        />
        <path
          d="M294.182 255.952H298.206V227.043H298.307L307.36 255.952H310.479L320.035 227.043H320.136V255.952H324.16V222.426H317.822L309.171 249.126H309.07L300.721 222.426H294.182V255.952Z"
          fill="#05509E"
        />
        <path
          d="M329.793 255.952H346.089V252.338H334.119V240.494H344.983V236.679H334.119V226.14H345.486V222.426H329.793V255.952Z"
          fill="#05509E"
        />
        <path
          d="M350.415 222.426H354.741V255.952H350.415V222.426Z"
          fill="#05509E"
        />
        <path
          d="M374.156 223.228C372.647 222.626 370.333 222.124 368.12 222.124C363.09 222.124 358.865 225.035 358.865 230.456C358.865 234.772 360.173 236.779 366.209 240.393C370.736 243.103 371.339 244.609 371.339 247.219C371.339 249.929 369.227 252.438 365.404 252.438C363.392 252.438 360.978 251.435 359.066 250.33V254.647C360.877 255.55 363.392 256.052 366.108 256.052C372.546 256.052 375.866 251.937 375.866 246.616C375.866 242.802 374.156 239.891 368.925 236.88C364.096 234.069 363.291 232.764 363.291 230.656C363.291 227.846 365.303 225.637 368.522 225.637C370.534 225.637 372.647 226.24 374.256 227.143V223.228H374.156Z"
          fill="#05509E"
        />
        <path
          d="M393.772 223.228C392.263 222.626 389.949 222.124 387.736 222.124C382.706 222.124 378.481 225.035 378.481 230.456C378.481 234.772 379.789 236.779 385.825 240.393C390.352 243.103 390.955 244.609 390.955 247.219C390.955 249.929 388.843 252.438 385.02 252.438C383.008 252.438 380.594 251.435 378.683 250.33V254.647C380.493 255.55 383.008 256.052 385.624 256.052C392.062 256.052 395.382 251.937 395.382 246.616C395.382 242.802 393.671 239.891 388.44 236.88C383.612 234.069 382.807 232.764 382.807 230.656C382.807 227.846 384.819 225.637 388.038 225.637C390.05 225.637 392.163 226.24 393.772 227.143V223.228Z"
          fill="#05509E"
        />
        <path
          d="M399.707 255.952H403.731V228.448H403.832L416.406 255.952H421.738V222.426H417.714V250.13H417.613L404.938 222.426H399.707V255.952Z"
          fill="#05509E"
        />
        <path
          d="M427.371 255.952H443.668V252.338H431.596V240.494H442.561V236.679H431.596V226.14H443.064V222.426H427.371V255.952Z"
          fill="#05509E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M447.993 255.952H452.218V240.795H454.13C457.248 240.795 458.455 241.798 459.461 244.609L463.284 255.952H467.811L463.083 242.501C462.379 240.594 461.473 239.59 459.461 239.289V239.189C464.391 238.185 466.101 234.772 466.101 231.158C466.101 228.749 465.296 226.441 463.586 224.835C462.077 223.429 460.065 222.526 456.544 222.526H447.993V255.952ZM452.118 225.939H455.438C459.16 225.939 461.574 227.746 461.574 231.46C461.574 234.37 459.864 237.382 455.337 237.382H452.118V225.939Z"
          fill="#05509E"
        />
        <path
          d="M59.9949 336.354C93.7951 284.76 154.656 264.685 242.979 275.927C270.844 278.436 295.993 276.73 318.023 270.707C241.068 324.309 155.058 346.192 59.9949 336.354Z"
          fill="#BDBCBC"
        />
        <path
          d="M444.171 135.097C428.679 163.403 411.779 189 393.973 210.982L391.458 214.094H404.134L404.737 213.291C420.531 190.405 435.017 164.708 447.792 136.803L444.171 135.097Z"
          fill="#05509E"
        />
        <path
          d="M342.468 263.781L341.965 264.283C302.934 297.307 258.068 320.595 208.676 333.544C159.283 346.593 103.855 349.705 43.8994 342.678L41.4851 342.377L45.1066 375.903L46.7161 376.004C57.6811 376.606 68.4448 376.907 79.108 376.907C131.82 376.907 180.509 369.379 223.866 354.322C275.974 336.254 322.047 306.944 360.777 267.094L363.996 263.781H342.468Z"
          fill="#05509E"
        />
      </g>
    </svg>
  );
}

export const WerraMeissner: InsuranceCorporateIdentity = {
  id: "werra-meissner",
  name: "Werra-Meissner",
  logo: WerraMeissnerLogo,
  backgroundColor: "white",
  textColor: "#000000",
  wildcard: "werra",
  type: "statutory",
};
